import { Avatar, List, ListItem, ListItemText, MuiThemeProvider } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {
    ERROR_PATHS,
    TRUSTCENTER_AGREEMENT_REPORT_PAGES,
    TRUSTCENTER_PAGES,
    TRUSTCENTER_V2_PAGES,
    FUELVENDOR_PAGES,
    USER_V2_RESOURCE,
    TERMS_V2_ENABLED,
    TRUSTCENTER_RESOURCE,
    AGREEMENT_REPORT_FEATURE,
    DOMAIN_NAME,
    TRUSTCENTER_AGREEMENT_REPORT_FEATURE,
    TRUSTCENTER_FEATURE,
    FUELVENDOR_FEATURE,
    FUELVENDOR_RESOURCE,
    RESTRICTED,
    IAM_REDIRECT_URL,
    VISIBILITY_PROVIDER,
    SYSTEM_ADMIN,
    SHARING_AGREEMENTS,
    ROUTES
} from './../../constants/Constants';
import {
    CARRIER_AGREEMENT_SURFACES,
    getCarrierAgreementSurfaces,
    hasCarrierSurface,
    isCarrierAgreementContext
} from 'components/TrustCenter/carrierAgreementSurfaces';
import { default as AccountCircleIcon } from '@material-ui/icons/AccountCircle';
import SignedIcon from '@material-ui/icons/BarChart';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import MenuIcon from '@material-ui/icons/Menu';
import DescriptionIcon from '@material-ui/icons/Description';
import cs from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import SVG from 'react-inlinesvg';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleAccountMapping } from 'store/actions';
import classesCss from './Header.module.css';
import theme, { SIDEBAR_THEME_ICON } from './HeaderMuiTheme';
import TrimbleAppLauncher from '@tcx/trimble-app-launcher/lib/AppLauncher';
import { toggleTerms } from '../../store/actions/termsAndConditionsActions';
import Badge from '@material-ui/core/Badge';
import Footer from 'components/Footer/Footer';
import { isBlank } from '../Common/Utils/StringUtils';
import { AccountSwitch } from '@ttc/accountwidget/dist/accountwidget.js';
import '@ttc/accountwidget/dist/style.css';
import useAccessToken from 'components/Common/Utils/hook';
import { signOut } from 'components/Common/Utils/ResourceUtils';

const styles = {
    list: {
        width: '100%'
    },
    listBottom: {
        paddingBottom: 5,
        width: '100%',
        bottom: 0,
        left: 0,
        position: 'absolute'
    },
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 10
    },
    logo: {
        fill: '#fff'
    },
    yellowLine: {
        backgroundColor: '#00437b !important',
        height: 4
    },
    headerTitle: {
        display: 'flex'
    },
    borderLine: {
        paddingRight: '23px',
        borderRight: '1px solid #ffffff!important'
    },
    pageTitle: {
        color: '#ffffff!important',
        width: '100%!important'
    },
    companyLogo: {
        fill: 'white'
    },
    navigationTitle: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '10px'
    },
    navigationLogo: {
        fill: '#154e8f'
    },
    separator: {
        borderLeft: '1px solid #fff',
        height: 30,
        margin: '5px 5px 5px 10px'
    },
    title: {
        fontSize: 16,
        color: '#fff',
        margin: 8
    },
    accountSwitch: {
        display: 'flex',
        gap: '28px'
    }
};

const getAccountId = (sessionValue, state) =>
    TERMS_V2_ENABLED ? sessionValue.accountUuid : state.accountId;

const getResourceName = () => (TERMS_V2_ENABLED ? USER_V2_RESOURCE : TRUSTCENTER_RESOURCE);

const getFeatureName = () =>
    TERMS_V2_ENABLED ? AGREEMENT_REPORT_FEATURE : TRUSTCENTER_AGREEMENT_REPORT_FEATURE;

const Header = (props) => {
    const {
        classes,
        sidebarResource,
        session,
        currentPage,
        enableOperation,
        selectedAccount,
        isTitanServiceEnabled,
        isCloudHubConnectorActive,
        isCloudHubConnectorStatusLoaded,
        isCloudHubConnectorStatusError
    } = props;

    const [state, setState] = useState({
        isCarrier: session.isCarrier,
        isTenantIdMapped: session.isTenantIdMapped,
        isCompanyIdMapped: session.isCompanyIdMapped,
        isUser: session.isUser,
        isSystemAdmin: session.userRole === SYSTEM_ADMIN,
        isVisibilityProvider: session?.accountType?.includes(VISIBILITY_PROVIDER),
        userRole: session.userRole,
        userName: session.userName,
        accountId: session.accountId
    });

    const [drawer, setDrawer] = useState(false);
    const accessToken = useAccessToken();

    useEffect(() => {
        const {
            isTenantIdMapped,
            isCompanyIdMapped,
            isUser,
            isCarrier,
            userRole,
            userName,
            accountId,
            isTitanServiceEnabled
        } = session;
        setState({
            isTenantIdMapped,
            isCompanyIdMapped,
            isUser,
            isCarrier,
            isSystemAdmin: userRole === SYSTEM_ADMIN,
            isVisibilityProvider: session?.accountType?.includes(VISIBILITY_PROVIDER),
            userRole,
            userName,
            accountId,
            isTitanServiceEnabled
        });
    }, [session]);

    const toggleDrawer = (open) => {
        setDrawer(open);
    };

    const toggleDrawerFromAppBar = () => {
        setDrawer(!drawer);
    };

    const openIAM = () => {
        window.open(IAM_REDIRECT_URL + `/account-detail/${session.accountId}`);
    };

    const isSignedInLatest = () => {
        return props.loggedInUserTerms.version === props.termsAndConditions.version;
    };

    const isResourceViewable = (resourceName) => {
        if (Object.entries(sidebarResource).length !== 0 && sidebarResource !== undefined) {
            if (
                sidebarResource[resourceName] !== undefined &&
                sidebarResource[resourceName] !== null
            ) {
                return sidebarResource[resourceName][0]?.permission?.read;
            }
        }
        return false;
    };
    const { isSystemAdmin, isVisibilityProvider, userRole } = state;
    const effectiveAccountId =
        isSystemAdmin && selectedAccount?.id ? selectedAccount.id : session.selected_accountId;
    const carrierContext = isCarrierAgreementContext(session, selectedAccount);
    const carrierAgreementSurfaces = getCarrierAgreementSurfaces({
        isCarrierContext: carrierContext,
        isTitanServiceEnabled,
        isCloudHubConnectorActive
    });
    const carrierAvailabilityError =
        carrierContext && isTitanServiceEnabled && isCloudHubConnectorStatusError;
    const carrierAvailabilityReady =
        !carrierAvailabilityError &&
        (!carrierContext || !isTitanServiceEnabled || isCloudHubConnectorStatusLoaded);
    const showCarrierV1 = carrierAvailabilityReady && hasCarrierSurface(
        carrierAgreementSurfaces,
        CARRIER_AGREEMENT_SURFACES.V1
    );
    const showCarrierV2 = carrierAvailabilityReady && hasCarrierSurface(
        carrierAgreementSurfaces,
        CARRIER_AGREEMENT_SURFACES.V2
    );
    const TrimbleLogo = process.env.PUBLIC_URL + '/img/logo.svg';

    let sideList = (
        <MuiThemeProvider theme={SIDEBAR_THEME_ICON}>
            <div className={classes.list}>
                <div id={'trimbleLogo'} className={cs(classes.navigationTitle, classes.grow)}>
                    <SVG
                        src={TrimbleLogo}
                        className={cs('d-none', 'd-sm-block', classes.navigationLogo)}
                    />
                </div>
                <Typography className={classesCss.sidebarTitle}>Trust Center</Typography>
                <List>
                    {isResourceViewable(TRUSTCENTER_RESOURCE, TRUSTCENTER_FEATURE) &&
                    carrierContext &&
                    showCarrierV1 ? (
                        <React.Fragment>
                            <Link
                                to={
                                    isSystemAdmin
                                        ? `/connections?accountId=${effectiveAccountId}`
                                        : '/connections'
                                }
                            >
                                <ListItem
                                    button
                                    className={
                                        TRUSTCENTER_PAGES.includes(currentPage)
                                            ? classesCss.selectedBackground
                                            : classesCss.defaultBackground
                                    }
                                >
                                    <Avatar
                                        className={
                                            TRUSTCENTER_PAGES.includes(currentPage)
                                                ? classesCss.selectedListColor
                                                : classesCss.defaultListColor
                                        }
                                    >
                                        <VerifiedUserIcon />
                                    </Avatar>
                                    <ListItemText
                                        primary={'Data Connections'}
                                        id={'sidebar-menu-item'}
                                    />
                                </ListItem>
                            </Link>
                        </React.Fragment>
                    ) : null}
                    {isResourceViewable(TRUSTCENTER_RESOURCE, TRUSTCENTER_FEATURE) &&
                    carrierContext &&
                    showCarrierV2 ? (
                        <React.Fragment>
                            <Link
                                to={
                                    isSystemAdmin
                                        ? `/connections/v2?accountId=${effectiveAccountId}`
                                        : ROUTES.CONNECTIONS_V2
                                }
                            >
                                <ListItem
                                    button
                                    className={
                                        TRUSTCENTER_V2_PAGES.includes(currentPage)
                                            ? classesCss.selectedBackground
                                            : classesCss.defaultBackground
                                    }
                                >
                                    <Avatar
                                        className={
                                            TRUSTCENTER_V2_PAGES.includes(currentPage)
                                                ? classesCss.selectedListColor
                                                : classesCss.defaultListColor
                                        }
                                    >
                                        <DescriptionIcon />
                                    </Avatar>
                                    <ListItemText
                                        primary={'Sharing Agreements'}
                                        id={'sidebar-menu-item'}
                                    />
                                </ListItem>
                            </Link>
                        </React.Fragment>
                    ) : null}
                    {isResourceViewable(FUELVENDOR_RESOURCE, FUELVENDOR_FEATURE) ? (
                        <React.Fragment>
                            <Link
                                to={
                                    isSystemAdmin
                                        ? `/fuelcardpartners?accountId=${session.selected_accountId}`
                                        : '/fuelcardpartners'
                                }
                            >
                                <ListItem
                                    button
                                    className={
                                        FUELVENDOR_PAGES.includes(currentPage)
                                            ? classesCss.selectedBackground
                                            : classesCss.defaultBackground
                                    }
                                >
                                    <Avatar
                                        className={
                                            FUELVENDOR_PAGES.includes(currentPage)
                                                ? classesCss.selectedListColor
                                                : classesCss.defaultListColor
                                        }
                                    >
                                        <LocalGasStationIcon />
                                    </Avatar>
                                    <ListItemText
                                        primary={'Fuel Card Partners'}
                                        id={'sidebar-menu-item'}
                                    />
                                </ListItem>
                            </Link>
                        </React.Fragment>
                    ) : null}

                    {isResourceViewable(getResourceName(), getFeatureName()) &&
                        !isSystemAdmin &&
                        carrierContext ? (
                        <React.Fragment>
                            <Link to={`/agreement-report/${getAccountId(session, state)}`}>
                                <ListItem
                                    button
                                    className={
                                        TRUSTCENTER_AGREEMENT_REPORT_PAGES.includes(currentPage)
                                            ? classesCss.selectedBackground
                                            : classesCss.defaultBackground
                                    }
                                >
                                    <Avatar
                                        className={
                                            TRUSTCENTER_AGREEMENT_REPORT_PAGES.includes(currentPage)
                                                ? classesCss.selectedListColor
                                                : classesCss.defaultListColor
                                        }
                                    >
                                        <SignedIcon />
                                    </Avatar>
                                    <ListItemText
                                        primary={'Terms of Use Report'}
                                        id={'sidebar-menu-item'}
                                    />
                                </ListItem>
                            </Link>
                        </React.Fragment>
                    ) : null}
                    {isVisibilityProvider ? (
                        <>
                            <Link to={ROUTES.SHARING_AGREEMENTS}>
                                <ListItem
                                    button
                                    className={
                                        SHARING_AGREEMENTS === currentPage
                                            ? classesCss.selectedBackground
                                            : classesCss.defaultBackground
                                    }
                                >
                                    <Avatar
                                        className={
                                            SHARING_AGREEMENTS === currentPage
                                                ? classesCss.selectedListColor
                                                : classesCss.defaultListColor
                                        }
                                    >
                                        <DescriptionIcon />
                                    </Avatar>
                                    <ListItemText
                                        primary={'Sharing agreements'}
                                        id={'sidebar-menu-item'}
                                    />
                                </ListItem>
                            </Link>
                        </>
                    ) : null}
                    {!isSystemAdmin ? (
                        <Link onClick={openIAM}>
                            <ListItem button className={classesCss.defaultBackground}>
                                <Avatar className={classesCss.defaultListColor}>
                                    <AccountCircleIcon />
                                </Avatar>
                                <ListItemText
                                    primary={'Account Management'}
                                    id={'sidebar-menu-item'}
                                >
                                    <Link onClick={openIAM} />
                                </ListItemText>
                            </ListItem>
                        </Link>
                    ) : null}
                </List>
            </div>
        </MuiThemeProvider>
    );

    const unauthorizedUser = () => {
        return ERROR_PATHS.some((errorPath) => window.location.href.includes(errorPath));
    };

    if (userRole === 'Restricted' || unauthorizedUser()) {
        sideList = <div />;
    }

    const sysAdminMessageBar = (
        <div className={classesCss.sysAdminLabel}>
            <label>
                {`Logged in as ${session.userName} viewing ${selectedAccount?.name ?? ''} ${selectedAccount?.status
                    ? selectedAccount.status.charAt(0).toUpperCase() +
                    selectedAccount.status.slice(1).toLowerCase()
                    : ''
                    } Account`}
            </label>
        </div>
    );

    return (
        <div className={classes.root}>
            <MuiThemeProvider theme={theme}>
                <AppBar id={'app-bar'} position="fixed" style={{ paddingRight: 0 }}>
                    <Toolbar id={'tool-bar'} className={'save-buttons'}>
                        {userRole === RESTRICTED ||
                            unauthorizedUser() ||
                            !enableOperation ? null : (
                            <IconButton
                                className={classes.menuButton}
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => toggleDrawerFromAppBar()}
                                id={'sideBarMenu'}
                            >
                                {props.termsNotify && !isSignedInLatest() ? (
                                    <Badge badgeContent={'!'} color={'primary'}>
                                        <MenuIcon />
                                    </Badge>
                                ) : (
                                    <MenuIcon />
                                )}
                            </IconButton>
                        )}
                        <div
                            id={'trimbleLogo'}
                            className={cs(classes.headerTitle, classes.grow, classes.borderLine)}
                        >
                            <SVG
                                src={TrimbleLogo}
                                className={cs('d-none', 'd-sm-block', classes.companyLogo)}
                            />
                        </div>
                        <Divider orientation="vertical" />
                        <div id={'headerTitle'} className={cs(classes.pageTitle, classes.grow)}>
                            <Typography
                                variant="h6"
                                color="inherit"
                                className={classesCss.headerTitle}
                            >
                                {userRole === RESTRICTED || unauthorizedUser()
                                    ? null
                                    : enableOperation
                                        ? 'Trust Center'
                                        : ''}
                            </Typography>
                        </div>
                        <div className={classes.grow} />
                        <div className={classes.accountSwitch}>
                            <TrimbleAppLauncher />
                            {!isBlank(accessToken) && (
                                <AccountSwitch
                                    domainurl={DOMAIN_NAME}
                                    signOut={signOut}
                                    token={accessToken}
                                />
                            )}
                        </div>
                    </Toolbar>
                    {isSystemAdmin ? sysAdminMessageBar : null}
                </AppBar>
                <div style={{ marginTop: 55 }} />
                <SwipeableDrawer
                    open={drawer}
                    onClose={() => toggleDrawer(false)}
                    onOpen={() => toggleDrawer(true)}
                    style={{ width: 280, padding: 10, zIndex: 1000 }}
                >
                    <div
                        tabIndex={0}
                        role="button"
                        onClick={() => toggleDrawer(false)}
                        onKeyDown={() => toggleDrawer(false)}
                    >
                        {sideList}
                    </div>
                    <Footer />
                </SwipeableDrawer>
            </MuiThemeProvider>
            <Footer displayFooter />
        </div>
    );
};

const mapStateToProps = (state) => ({
    sidebarResource: state.header.sidebarResource,
    currentPage: state.header.currentPage,
    session: state.session.sessionValue,
    enableOperation: state.header.enableHeaderOperation,
    termsNotify: state.termsAndConditions.termsNotify,
    termsAndConditions: state.termsAndConditions.termsAndConditions,
    loggedInUserTerms: state.termsAndConditions.loggedInUserTerms,
    openCloseTerms: state.termsAndConditions.openCloseTerms,
    selectedAccount: state.accounts.selectedAccount,
    isTitanServiceEnabled: state.agreementV2.isTitanServiceEnabled,
    isCloudHubConnectorActive: state.agreementV2.isCloudHubConnectorActive,
    isCloudHubConnectorStatusLoaded: state.agreementV2.isCloudHubConnectorStatusLoaded,
    isCloudHubConnectorStatusError: state.agreementV2.isCloudHubConnectorStatusError
});

Header.propTypes = {
    classes: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
    toggleAccountMapping,
    toggleTerms
})(withStyles(styles)(Header));
